import { PhoneOutlined } from "@ant-design/icons";
import type { DragEvent } from "react";
import type { LeadItem } from "../types/lead.types";
import { LeadSourceBadge } from "./LeadSourceBadge";

type LeadCardProps = {
	lead: LeadItem;
	onDragStart: (leadId: string) => void;
	onOpen: (lead: LeadItem) => void;
};

export function LeadCard({ lead, onDragStart, onOpen }: LeadCardProps) {
	const handleDragStart = (event: DragEvent<HTMLButtonElement>) => {
		event.dataTransfer.effectAllowed = "move";
		event.dataTransfer.setData("text/plain", String(lead.id));
		onDragStart(lead.id);
	};

	const metaItems = [lead.buildingName, lead.roomInterest, lead.budget].filter(Boolean);
	const showBottomRow = Boolean(lead.managerName || lead.calls > 0);

	return (
		<button
			className="crm-lead-card"
			draggable
			onClick={() => onOpen(lead)}
			onDragStart={handleDragStart}
			type="button"
		>
			<div className="crm-lead-card-top">
				<div>
					<strong>{lead.name}</strong>
					<span>
						<PhoneOutlined />
						{lead.phone}
					</span>
				</div>
				<LeadSourceBadge source={lead.source} />
			</div>

			{metaItems.length > 0 ? (
				<div className="crm-lead-card-meta">
					{metaItems.map((item) => (
						<span key={item}>{item}</span>
					))}
				</div>
			) : null}

			{showBottomRow ? (
				<div className="crm-lead-card-bottom">
					{lead.managerName ? (
						<span className="crm-lead-manager">
							<i>{lead.managerInitials}</i>
							<span className="crm-lead-manager-name">{lead.managerName}</span>
						</span>
					) : null}
					{lead.calls > 0 ? <span className="crm-badge red">{lead.calls} javobsiz</span> : null}
				</div>
			) : null}
		</button>
	);
}
